import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import moment from "moment";

const OngoingEvents = ({
  data,
  navigate,
  title,
  isMobile,
  slice,
  setSlice,
  sx,
}) => {
  return (
    <>
      <Stack width="100%" height="100%" gap={4}>
        <Grid
          container
          padding={2}
          paddingRight={{ xs: 2, sm: 4, md: 5 }}
          paddingLeft={{ xs: 2, sm: 4, md: 5 }}
          spacing={2}
          width="100%"
        >
          <Grid item xs={12}>
            <h2
              variant="h4"
              style={{ paddingX: { xs: "5px", sm: "10px" }, fontSize: sx.fontSizeHeading,
              fontFamily: sx.fontFamilyHeading,
              fontWeight: sx.fontWeightHeading, }}
            >
              {title}
            </h2>
          </Grid>
          <Grid
            item
            container
            alignItems={"center"}
            justifyContent={data?.length % 2 === 0 ? "" : "center"}
            xs={12}
          >
            {data.slice(0, slice)?.map((event) => (
              <Grid item xs={12} sm={6} md={6} key={event.id}>
                <Stack
                  minHeight="max-content"
                  sx={{
                    borderRadius: "32px",
                    width: "100%",
                    height: { xs: "400px", sm: "450px", md: "500px" },
                    marginBottom: "20px",
                  }}
                >
                  <Box
                    sx={{
                      padding: "10px",
                      marginBottom: "10px",
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{
                        backgroundImage: `url(${event.event_img_path})`,
                        height: { xs: "300px", sm: "350px", md: "400px" },
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "32px",
                        width: "100%",
                      }}
                      spacing={2}
                    ></Stack>
                    <Stack
                      position="absolute"
                      bottom={{ xs: "-5%", sm: "-10%" }}
                      justifyContent="center"
                      alignItems="end"
                      sx={{
                        borderRadius: "25px",
                        width: "90%",
                        background: "#FE3B3E",
                      }}
                    >
                      <Stack
                        sx={{
                          borderRadius: "20px 25px 25px 20px",
                          width: "98%",
                          background: "white",
                        }}
                        padding={2}
                        spacing={1}
                      >
                        <p
                          style={{
                            
                            color: sx.textColor || "black",
                            fontSize: sx.fontSizeHeading,
              fontFamily: sx.fontFamilyHeading,
              fontWeight: sx.fontWeightHeading,
                          }}
                        >
                          {event.event_name}
                        </p>
                        <Stack
                          alignItems="end"
                          direction="row"
                          sx={{
                            color: "#565656",
                            fontSize: sx.fontSize ? sx.fontSize : { xs: "14px", sm: "16px" },
                            fontWeight: sx.fontWeight ? sx.fontWeight : "500",
                            fontFamily: sx.fontFamily,
                            gap: "10px",
                          }}
                        >
                          <FmdGoodOutlinedIcon sx={{ color: "#FE3B3E" }} />
                          <Typography>{event.event_address}</Typography>
                        </Stack>
                        <Stack
                          direction={isMobile ? "column" : "row"}
                          alignItems="end"
                          sx={{
                            color: "#565656",
                            fontSize: sx.fontSize ? sx.fontSize : { xs: "14px", sm: "16px" },
                            fontWeight: sx.fontWeight ? sx.fontWeight : "500",
                            fontFamily: sx.fontFamily,
                            gap: "10px",
                          }}
                        >
                          <Stack direction="row" width={"100%"} gap={"10px"}>
                            <CalendarTodayOutlinedIcon
                              sx={{ color: "#FE3B3E" }}
                            />
                            <Typography width={"100%"}>
                              <span className="fw-bold">Pre-Order Date:</span> {moment(event.preorder_start_date).format(
                                "MMM DD, YYYY"
                              )} -  {moment(event.preorder_end_date).format(
                                "MMM DD, YYYY"
                              )}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack
                          direction={isMobile ? "column" : "row"}
                          alignItems="end"
                          sx={{
                            color: "#565656",
                            fontSize: sx.fontSize ? sx.fontSize : { xs: "14px", sm: "16px" },
                            fontWeight: sx.fontWeight ? sx.fontWeight : "500",
                            fontFamily: sx.fontFamily,
                            gap: "10px",
                          }}
                        >
                          <Stack direction="row" width={"150%"} gap={"10px"}>
                            <CalendarTodayOutlinedIcon
                              sx={{ color: "#FE3B3E" }}
                            />
                            <Typography width={"100%"}>
                              <span className="fw-bold">Event Date:</span> {moment(event.event_start_date).format(
                                "MMM DD, YYYY"
                              )} -  {moment(event.event_end_date).format(
                                "MMM DD, YYYY"
                              )}
                            </Typography>
                          </Stack>
                          <Stack
                            alignItems="end"
                            justifyContent="end"
                            width={"100%"}
                            direction={isMobile ? "column" : "row"}
                          >
                            <a href={window.location.href + event?.event_link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                              <Button
                                variant="contained"
                                disableElevation
                                endIcon={<EastOutlinedIcon />}
                                sx={{
                                  backgroundColor: "#FE3B3E",
                                  color: "white",
                                  borderRadius: "12px",
                                  fontSize: sx.fontSize ? sx.fontSize : { xs: "14px", sm: "16px" },
                                  fontWeight: sx.fontWeight ? sx.fontWeight : "500",
                                  fontFamily: sx.fontFamily,
                                  padding: "5px",
                                  paddingX: "10px",
                                  width: isMobile ? "100%" : "auto",
                                  transition: "all 0.3s ease-in-out",
                                  "&:hover": {
                                    backgroundColor: "white",
                                    color: "#FE3B3E",
                                  },
                                }}
                              >
                                Visit Store
                              </Button>
                            </a>

                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Stack width="100%" justifyContent="center" alignItems="center">
            {data.length > slice && (
              <Button
                onClick={() => setSlice(slice + 2)}
                sx={{
                  color: "#FE3B3E",
                  borderColor: "#FE3B3E",
                  border: "2px solid",
                  borderRadius: "10px",
                  fontSize: sx.fontSize ? sx.fontSize : { xs: "16px", sm: "20px" },
                  fontWeight: sx.fontWeight ? sx.fontWeight : "600",
                  fontFamily: sx.fontFamily,
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#FE3B3E",
                    color: "white",
                    border: "2px solid #FE3B3E",
                  },
                }}
                variant="outlined"
              >
                Load More
              </Button>
            )}
          </Stack>
        </Grid>
      </Stack>
    </>
  );
};

export default OngoingEvents;
